import { getErrorPrefix, removeProductError } from './common-utils.js';
import handleError from './handle-error.js';
import {
	getRecaptcha,
} from './recaptcha.js';

const LAMBDA_URL = document.querySelector('meta[name="sumo:signup_url"]').content || '';

const convertFormData = (formData) => {
	const obj = {};
	formData.forEach((value, key) => {
		if (value !== '') {
			obj[key] = value;
		}
	});
	return obj
}

const req = (endpoint, fields) => {
	const body = JSON.stringify(fields);
	const headers = new Headers({
		'Content-Type': 'application/json',
	});
	const options = {
		method: 'POST',
		body,
		headers,
	}
	const req = new Request(`${LAMBDA_URL}${endpoint}`, options);

	return fetch(req).then(async (response) => {
		let msg;

		if (!response.ok) {
			msg = await response.json();
			handleError(msg, req.url);
			throw new Error(msg.join(';'));
		};
		return response.json();
	}).then((msg) => {
		removeProductError(getErrorPrefix(req.url));
		return msg;
	});
}

export const emailRequest = async (fields) => {
	fields.recaptcha = await getRecaptcha();
	return req('/email', fields);
}

export const signupRequest = async (fields) => {
	fields.recaptcha = await getRecaptcha();
	return req('/signup', fields);
}

export const tokenRequest = async (fields) => {
	fields.append('recaptcha', await getRecaptcha());
	return req('/token', convertFormData(fields));
}

export const tokenVerifyRequest = async (token) => {
	const fields = {
		'recaptcha': await getRecaptcha(),
		token,
	};
	return req('/token/verify', fields);
}
